import { registerModule } from '@/app/app.store'
import { STORE } from './city-choose.store'

export default {
    beforeEnter: (to: any, from: any, next: () => void) => {
        registerModule('cityChoose', STORE)
        next()
    },
    path: '/city-choose',
    name: 'city-choose',
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    component: () => import('./city-choose.vue')
}
